
/**生成多层级Tab**/
import tabsTpl from './tabs.tmpl';
import dailyTabTpl from './daily-tabs-tpl.tmpl';
import listTpl from './list.tmpl';
import dailyListTpl from './daily-list.tmpl'
import itemEmptyTpl from './empty-item.tmpl';

class CreateTabAndList {

	constructor(acid,container){
		this.index = 0;
        this.acid = acid;
        let configs = UpAct.CONFIG.acidConfig;
		let actIdMap = this.renderacidMap(configs);
        this.actIdMap = actIdMap;
		//this.renderTabs(configs,container);
        this.refresh();
	}
	renderacidMap(acidInfo, actIdMap= {}){
		let self = this;
		let acid = acidInfo.acid;
		if ($.isArray(acid)){
			if (acid.length > 0){
				acid.forEach(function(item,index){
					actIdMap[item.uniqueId] = item;
					
					if (item.acid) {
						self.renderacidMap(item, actIdMap);
					}
				})
				return actIdMap;
			}
		} else {
			actIdMap[acidInfo.uniqueId] = acidInfo;
			
			return actIdMap;
		}
	}

	renderTabs(tabsConfig,panel,tabIndex=0){
        let self = this;
        let tabs = tabsConfig.acid;
        if($.isArray(tabs)){
            let length = tabs.length;
            let html = tabsTpl({
                tabs: tabs,
                tabObjIndex: tabIndex,
                tabLength: length
            });
            $(panel).html(html);
            let selectIndex = self.getSelectIndex(tabIndex);
            let tabView = new UpAct.TabView({
                wrap: $(panel),
                selectedIndex: selectIndex,
                direction: UpAct.lang.langType == 'areg' ? 'right':'left'
            });
            self.index++;
            tabView.on('select',(e)=>{
                let currentTarget = $(e.tab);
                let _panel = e.panel;
                let _index = e.index;
                let tabIndex = currentTarget.data('tabindex');
                let _uniqueId = currentTarget.data('uniqueid');
                let _acidInfo = self.actIdMap[_uniqueId];
                self.renderTabs(_acidInfo,_panel,tabIndex+1);
            });
            tabView.render();
        }else if(typeof tabs == 'object'){
            self.renderTabs(tabs,panel,tabIndex);

        }else{
            let listStyle = tabsConfig.listStyle;
	        let acid = tabsConfig.acid;
            
	        let actInfo = UpAct.actData[acid];
	        self.actInfo = actInfo;
            if(listStyle == 'rb'){
                self.renderDailyTabs(tabsConfig,panel);
            }else{
            	let cfg = actInfo.overallRanking;
                let html = listTpl({
                    actInfo: actInfo,
                    cfg: cfg
                });
                $(panel).html(html);
                self.renderList(tabsConfig,panel);
            }
        }
    }
    getSelectIndex(tabIndex){
        let selectIndex = 0;
        switch(tabIndex){
            case 0:
                selectIndex = 0;
                break;
            case 1: 
                selectIndex = this.renderArea();
                break;
            case 2: 
                //selectIndex = this.getDefaultTab();

                selectIndex = 0;
                break;

            case 3:
                selectIndex = 1;
                break;

            default : 
                selectIndex = 0;
                break;
        }
        return selectIndex;

    }

    renderArea(){
        let self = this;
        let langType = UpAct.lang.langType;
        let currentAcid, selectedAreaIndex;
        $.each(UpAct.CONFIG.acidConfig.acid, function(index, items) {
            if (items.uniqueId.indexOf(langType) > -1) {
                selectedAreaIndex = index;
            }
        });
        return selectedAreaIndex;
    }
    getDefaultTab(){
        let actInfo = UpAct.actData[this.acid];
        let defaultTabIndex = actInfo.status == 1 ? 1: 0;
        if(UpAct.lang.langType == 'areg'){
            defaultTabIndex = actInfo.status == 1 ? 0: 1;
        }
        return defaultTabIndex;
    }
    renderDailyTabs(tabsConfig,panel){
    	let self = this;
        let acid = tabsConfig.acid;
        self.actInfo = UpAct.actData[acid];
        let html = dailyTabTpl({
            actInfo: self.actInfo,
            dailyTabs: self.actInfo.dailyRanking
        });
        $(panel).html(html);
        let tabView = new UpAct.TabView({
                wrap: $(panel),
                selectedIndex: self.actInfo.status == 1 ? self.actInfo.currentDay.index : 0,
                direction: UpAct.lang.langType == 'areg' ? 'right':'left',
                scrollable: true
            });
            tabView.on('select',(e)=>{
                let _panel = e.panel;
                let _index = e.index;
                let actInfo = self.actInfo;

                let showCountDown = (actInfo.status == 1 && actInfo.currentDay.index == _index) ? true : false;
                let cfg = actInfo.dailyRanking[_index];
                let html = dailyListTpl({
                    actInfo: actInfo,
                    cfg: cfg,
                    showCountDown: showCountDown
                });
                $(_panel).html(html);
                self.renderList(tabsConfig,_panel);
                
            });
            tabView.render();
    }
    renderList(acidInfo,panel){
    	let self = this;
        let actInfo = self.actInfo;

        let listType = acidInfo.listType;

        if(UpAct[listType]){
        	self.hostList = new UpAct[listType]({
				wrap: $(panel),
				itemEmptyTpl:itemEmptyTpl,
                acidInfo: acidInfo
        	}).render();
        }
    }
    refresh() {
        let self = this;
        UpAct.refresh.off('refresh');
        UpAct.refresh.on('refresh', function() {
            self.hostList.refresh();
        });
        UpAct.refresh.render();
    }

}
module.exports = CreateTabAndList;


// WEBPACK FOOTER //
// ./js/component/createTabAndList/index.js